import { cloneDeep, find } from 'lodash'
import { mapActions, mapState, mapGetters } from 'vuex'
import formInput from '@/components/common/form-input/form-input.vue'
import formButton from '@/components/common/form-button/form-button.vue'
import Multiselect from 'vue-multiselect'
import editOption from '@/components/pages/main-pages/settings/attributes/edit-option/edit-option.vue'
import messages from '@/helpers/messages'
import router from '@/router'

export default {
  components: {
    formInput,
    formButton,
    Multiselect
  },
  data() {
    return {
      attribute: null,
      columns: ['id', 'text', 'country', 'edit'],
      tableOptions: {
        filterable: false,
        headings: {
          text: 'Text',
          edit: ' '
        },
        perPageValues: [10],
        orderBy: {
          column: 'text'
        },
        childRow: editOption
      }
    }
  },
  computed: {
    ...mapState('attributesTypes', ['statuses', 'currentlyEditedAttribute']),
    ...mapState('attributesOptions', ['currentlyEditedOptions']),
    ...mapState('countries', ['countriesList']),
    ...mapGetters('user', ['isSuperAdmin']),
    transformedOptions: function () {
      const options = cloneDeep(this.currentlyEditedOptions)
      options.forEach((option) => {
        option.country = this.getCountry(option.country_id)
        option.edit = this.toggleEditRow
      })
      return options
    }
  },
  methods: {
    ...mapActions('attributesOptions', ['getAttributesOptionsList']),
    ...mapActions('attributesTypes', ['updateAttributesType', 'deleteAttributeType']),
    getCountry: function (countryId) {
      return find(this.countriesList, (country) => country.id === countryId)
    },
    updateAttribute: async function () {
      try {
        await this.updateAttributesType({
          name: this.attribute.name,
          status: this.attribute.status,
          id: this.attribute.id
        })
        this.$notify({
          text: 'Attribute updated',
          type: 'success'
        })
      } catch (e) {
        this.$notify({
          text: 'Error while updating attribute',
          type: 'error'
        })
      }
    },
    toggleEditRow: function (id) {
      this.$refs.options_table.toggleChildRow(id)
    },
    onDeleteAttribute: async function () {
      try {
        await this.$dialog.confirm(messages.shouldDeleteItem)
        await this.deleteAttributeType({ id: this.attribute.id })
        this.$notify({
          text: `Attribute ${this.attribute.name} was deleted`,
          type: 'success'
        })
        router.push({ name: 'attributes' })
      } catch (e) {
        if (e === false) return
        this.$notify({
          text: 'Error while deleting attribute',
          type: 'error'
        })
      }
    }
  },
  async created() {
    try {
      this.attribute = cloneDeep(this.currentlyEditedAttribute)
      await this.getAttributesOptionsList({ type: this.currentlyEditedAttribute.name })
    } catch (e) {
      this.$notify({
        text: 'Error while getting options',
        type: 'error'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/attributes/attribute-edit/attribute-edit.js